import service from '@/services/facturacion/factura'
import { Session } from '@/plugins/session'

const getDefaultState = () => ({
  params: {},
  // factura creada en facturar.vue
  factura: {
    fechaEmisionOriginal: null,
    original: null,

    pagaCon: '',
    detalleServicio: {
      lineaDetalle: []
    },
    otrosCargos: [],
    resumenFactura: {
      medioPago: [{}],
      totalDescuentos: 0,
      totalImpuesto: 0,
      totalServGravados: 0,
      totalServExonerado: 0,
      totalMercanciasGravadas: 0,
      totalMercExonerada: 0,
      totalGravado: 0,
      totalExonerado: 0,
      totalVenta: 0,
      totalVentaNeta: 0,
      // const TotalIVADevuelto : No aplica en esta version.,
      totalComprobante: 0
    },
    informacionReferencia: [],

    cuentaContableIVAPorCobrar: null,
    cuentaContableIVAPorPagar: null
  },
  adjuntos: [],
  exoneracion: null,

  facturas: [],
  tiquetes: [],
  notasCredito: [],
  mensajesReceptor: [],
  compras: [],
  anulacionCompras: [],
  facturaExportacion: [],
  suscripcion: [],
  facturaOtros: [],

  proforma: {},
  facturaModalDocSelected: {},
  notaDebitoModalDocSelected: {},
  notaCreditoModalDocSelected: {},
  tiqueteModalDocSelected: {},
  mensajeReceptorModalDocSelected: {},
  comprasModalDocSelected: {},
  exportacionModalDocSelected: {},
  otrosModalDocSelected: {},
  creditoModalDocSelected: {},
  pagosModalDocSelected: {},
  pagosComprasModalDocSelected: {},
  suscripcionModalDocSelected: {},

  creditoComprasModalDocSelected: {},
  anulacionComprasModalDocSelected: {},

  facturasPageInfo: {},
  tiquetesPageInfo: {},
  notasCreditoPageInfo: {},
  mensajesReceptorPageInfo: {},
  comprasPageInfo: {},
  anulacionComprasPageInfo: {},
  facturaExportacionPageInfo: {},
  suscripcionPageInfo: {},
  facturaOtrosPageInfo: {},

  listaCredito: [],
  listaCreditoPageInfo: {},

  listaProforma: [],
  listaProformaPageInfo: {},

  listaCreditoCompras: [],
  listaCreditoComprasPageInfo: {},

  currentCreditoRow: null,
  currentCreditoComprasRow: null,
  currentProformaRow: null,
  currentRow: [
    {
      documento: '01',
      row: null
    },
    {
      documento: '03',
      row: null
    },
    {
      documento: '04',
      row: null
    },
    {
      documento: '05',
      row: null
    },
    {
      documento: '08', // 998 - 995
      row: null
    },
    {
      documento: '09',
      row: null
    },
    {
      documento: '99',
      row: null
    },
    {
      documento: '101',
      row: null
    }
  ],

  reporteVentas: [],
  reporteCompras: [],
  reporteVentasStats: [],
  totalesVentas: [
    {
      documentos: 0,
      clientes: 0,
      totalComprobante: 0.0,
      totalVentaNeta: 0.0,
      totalOtrosCargos: 0.0,
      totalImpuesto: 0.0
    }
  ],
  totalesCompras: [
    {
      documentos: 0,
      clientes: 0,
      totalComprobante: 0.0,
      totalVentaNeta: 0.0,
      totalImpuesto: 0.0
    }
  ],

  reporteNotasCredito: [],
  reporteNotasCreditoCompras: [],
  totalesNotasCredito: [
    {
      documentos: 0,
      clientes: 0,
      totalComprobante: 0.0,
      totalVentaNeta: 0.0,
      totalImpuesto: 0.0,
      totalOtrosCargos: 0.0
    }
  ],
  totalesNotasCreditoCompras: [
    {
      documentos: 0,
      clientes: 0,
      totalComprobante: 0.0,
      totalVentaNeta: 0.0,
      totalImpuesto: 0.0
    }
  ],

  totalGeneral: [
    {
      documentos: 0,
      clientes: 0,
      totalComprobante: 0.0,
      totalVentaNeta: 0.0,
      totalImpuesto: 0.0,
      totalOtrosCargos: 0.0
    }
  ],
  totalGeneralCompras: [
    {
      documentos: 0,
      clientes: 0,
      totalComprobante: 0.0,
      totalVentaNeta: 0.0,
      totalImpuesto: 0.0
    }
  ],
  mediosPago: [],

  totalRegistrosFe: 0,
  totalRegistrosNd: 0,
  totalRegistrosNc: 0,
  totalRegistrosTe: 0,
  totalRegistrosMr: 0,
  totalRegistrosFec: 0,
  totalRegistrosFee: 0,
  totalRegistrosOtros: 0,
  totalRegistrosCobrar: 0,
  totalRegistrosPagar: 0,

  saved: 'null',
  isListening: false,

  cajaSesion: {},
  codigoProductos: [0, 1, 2, 3, 4],
  codigoServicios: [5, 6, 7, 8, 9]
})

function unique(arr = [], feed = [], key = '_id') {
  const map = new Map()

  for (const item of arr) map.set(item[key], item)
  for (const item of feed) map.set(item[key], item)

  return [...map.values()]
}

export default class {
  constructor() {
    this.state = getDefaultState()
    this.mutations = {
      RESET_STATE: state => Object.assign(state, getDefaultState()),
      SET_ROW: (state, row) => {
        const crow = state.currentRow.find(r => r.documento === row?.documento.value)

        if (crow) crow.row = row
      },
      SET_ROW_FEC: (state, row) => {
        const crow = state.currentRow.find(r => r.documento === '08')

        if (crow) crow.row = row
      },
      CLONAR_FACTURA: (state, doc) => {
        state.factura = doc
      },
      SET_CREDITO_ROW: (state, row) => (state.currentCreditoRow = row),
      SET_CREDITO_COMPRAS_ROW: (state, row) => (state.currentCreditoComprasRow = row),
      SET_PROFORMA_ROW: (state, row) => (state.currentProformaRow = row),
      SET_DOCUMENTO: (state, { storeList, obj }) => {
        state[storeList] =
          obj.documento.value === '01'
            ? state.facturas.find(e => e.id === obj.id)
            : obj.documento.value === '03' || obj.documento.value === '993'
            ? state.notasCredito.find(e => e.id === obj.id)
            : obj.documento.value === '04'
            ? state.tiquetes.find(e => e.id === obj.id)
            : obj.documento.value === '05' || obj.documento.value === '06' || obj.documento.value === '07'
            ? state.mensajesReceptor.find(e => e.id === obj.id)
            : obj.documento.value === '08' || obj.documento.value === '998' || obj.documento.value === '995'
            ? state.compras.find(e => e.id === obj.id)
            : obj.documento.value === '09'
            ? state.facturaExportacion.find(e => e.id === obj.id)
            : obj.documento.value === '101' || obj.documento.value === '102' || obj.documento.value === '103'
            ? state.suscripcion.find(e => e.id === obj.id)
            : obj.documento.value === '9938'
            ? state.anulacionCompras.find(e => e.id === obj.id)
            : // : obj.documento.value === '99'
              state.facturaOtros.find(e => e.id === obj.id)

        state[storeList].id = obj.id
        state[storeList].clave = obj.clave
        state[storeList].codigoActividad = obj.codigoActividad
        state[storeList].codigoActividadEmisor = obj.codigoActividadEmisor
        state[storeList].codigoActividadReceptor = obj.codigoActividadReceptor
        state[storeList].situacionComprobante = obj.situacionComprobante
        state[storeList].documento = obj.documento
        state[storeList].condicionVenta = obj.condicionVenta
        state[storeList].emisor = obj.emisor
        state[storeList].receptor = obj.receptor
        state[storeList].detalleServicio = obj.detalleServicio
        state[storeList].otrosCargos = obj.otrosCargos
        state[storeList].resumenFactura = obj.resumenFactura
        state[storeList].informacionReferencia = obj.informacionReferencia
        state[storeList].local = obj.local
        state[storeList].terminal = obj.terminal
        state[storeList].plazoCredito = obj.plazoCredito
        state[storeList].otros = obj.otros

        // cajas
        if (obj.cajaSesion) state[storeList].cajaSesion = obj.cajaSesion
      },

      SET_DOCUMENTO_CREDITO: (state, { storeList, obj }) => {
        if (storeList === 'creditoModalDocSelected') state[storeList] = state.listaCredito.find(e => e.id === obj.id)
        else if (storeList === 'creditoComprasModalDocSelected') state[storeList] = state.listaCreditoCompras.find(e => e.id === obj.id)

        state[storeList].id = obj.id
        state[storeList].clave = obj.clave
        state[storeList].codigoActividad = obj.codigoActividad
        state[storeList].codigoActividadEmisor = obj.codigoActividadEmisor
        state[storeList].codigoActividadReceptor = obj.codigoActividadReceptor
        state[storeList].situacionComprobante = obj.situacionComprobante
        state[storeList].documento = obj.documento
        state[storeList].condicionVenta = obj.condicionVenta
        state[storeList].emisor = obj.emisor
        state[storeList].receptor = obj.receptor
        state[storeList].detalleServicio = obj.detalleServicio
        state[storeList].otrosCargos = obj.otrosCargos
        state[storeList].resumenFactura = obj.resumenFactura
        state[storeList].informacionReferencia = obj.informacionReferencia
        state[storeList].local = obj.local
        state[storeList].terminal = obj.terminal
        state[storeList].plazoCredito = obj.plazoCredito
        state[storeList].otros = obj.otros

        // cajas
        if (obj.cajaSesion) state[storeList].cajaSesion = obj.cajaSesion

        // posOrder
        if (obj.posOrder) state[storeList].posOrder = obj.posOrder
      },

      SET_FULL_DOCUMENTO_CREDITO: (state, { storeList, obj }) => {
        state[storeList] = obj
      },

      SET_FULL_DOCUMENTO: (state, { storeList, obj }) => {
        state[storeList] = obj
      },

      SET_DOCUMENTO_PROFORMA: (state, { obj }) => {
        state.proforma = state.listaProforma.find(e => e.id === obj.id)

        state.proforma.id = obj.id
        state.proforma.clave = obj.clave
        state.proforma.codigoActividad = obj.codigoActividad
        state.proforma.situacionComprobante = obj.situacionComprobante
        state.proforma.documento = obj.documento
        state.proforma.condicionVenta = obj.condicionVenta
        state.proforma.emisor = obj.emisor
        state.proforma.receptor = obj.receptor
        state.proforma.detalleServicio = obj.detalleServicio
        state.proforma.otrosCargos = obj.otrosCargos
        state.proforma.resumenFactura = obj.resumenFactura
        state.proforma.informacionReferencia = obj.informacionReferencia
        state.proforma.local = obj.local
        state.proforma.terminal = obj.terminal
        state.proforma.plazoProforma = obj.plazoProforma
        state.proforma.estadoProforma = obj.estadoProforma
        state.proforma.otros = obj.otros
      },

      SET_FULL_DOCUMENTO_PROFORMA: (state, { obj }) => {
        state.proforma = obj
      },

      SET_DOCUMENTO_PAGO: (state, { storeList, obj }) => {
        state[storeList] = obj
      },

      SET_LISTA_CREDITO: (state, obj) => {
        state.listaCredito = unique(state.listaCredito, obj.feed, 'id')
        state.listaCreditoPageInfo = obj.pageInfo
      },
      SET_LISTA_PROFORMA: (state, obj) => {
        state.listaProforma = unique(state.listaProforma, obj.feed, 'id')
        state.listaProformaPageInfo = obj.pageInfo
      },
      SET_LISTA_CREDITO_COMPRAS: (state, obj) => {
        state.listaCreditoCompras = unique(state.listaCreditoCompras, obj.feed, 'id')
        state.listaCreditoComprasPageInfo = obj.pageInfo
      },
      SET_FACTURA: (state, obj) => {
        state.factura = obj
      },
      SET_FACTURAS: (state, obj) => {
        state.facturas = unique(state.facturas, obj.feed, 'id')
        state.facturasPageInfo = obj.pageInfo
      },

      SET_NOTASCREDITO: (state, obj) => {
        state.notasCredito = [...new Set([...state.notasCredito.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
        state.notasCreditoPageInfo = obj.pageInfo
      },

      SET_TIQUETES: (state, obj) => {
        state.tiquetes = [...new Set([...state.tiquetes.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
        state.tiquetesPageInfo = obj.pageInfo
      },

      SET_FACTURAEXPORTACION: (state, obj) => {
        state.facturaExportacion = [...new Set([...state.facturaExportacion.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
        state.facturaExportacionPageInfo = obj.pageInfo
      },

      SET_FACTURAOTROS: (state, obj) => {
        state.facturaOtros = [...new Set([...state.facturaOtros.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
        state.facturaOtrosPageInfo = obj.pageInfo
      },

      SET_ANULACIONCOMPRAS: (state, obj) => {
        state.anulacionCompras = [...new Set([...state.anulacionCompras.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
        state.anulacionComprasPageInfo = obj.pageInfo
      },

      SET_SUSCRIPCION: (state, obj) => {
        state.suscripcion = [...new Set([...state.suscripcion.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
        state.suscripcionPageInfo = obj.pageInfo
      },

      SET_MENSAJES_RECEPTOR: (state, obj) => {
        state.mensajesReceptor = [...new Set([...state.mensajesReceptor.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
        state.mensajesReceptorPageInfo = obj.pageInfo
      },

      SET_COMPRAS: (state, obj) => {
        state.compras = [...new Set([...state.compras.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
        state.comprasPageInfo = obj.pageInfo
      },

      SET_FACTURAS_BY_DATE: (state, obj) => {
        state.facturas = obj.feed
        state.facturasPageInfo = obj.pageInfo
      },

      SET_CREDITO_BY_DATE: (state, obj) => {
        state.listaCredito = obj.feed
        state.listaCreditoPageInfo = obj.pageInfo
      },

      SET_NOTASCREDITO_BY_DATE: (state, obj) => {
        state.notasCredito = obj.feed
        state.notasCreditoPageInfo = obj.pageInfo
      },

      SET_TIQUETES_BY_DATE: (state, obj) => {
        state.tiquetes = obj.feed
        state.tiquetesPageInfo = obj.pageInfo
      },

      SET_FACTURAEXPORTACION_BY_DATE: (state, obj) => {
        state.facturaExportacion = obj.feed
        state.facturaExportacionPageInfo = obj.pageInfo
      },

      SET_FACTURAOTROS_BY_DATE: (state, obj) => {
        state.facturaOtros = obj.feed
        state.facturaOtrosPageInfo = obj.pageInfo
      },

      SET_SUSCRIPCION_BY_DATE: (state, obj) => {
        state.suscripcion = obj.feed
        state.suscripcionPageInfo = obj.pageInfo
      },

      SET_MENSAJES_RECEPTOR_BY_DATE: (state, obj) => {
        state.mensajesReceptor = obj.feed
        state.mensajesReceptorPageInfo = obj.pageInfo
      },

      SET_COMPRAS_BY_DATE: (state, obj) => {
        state.compras = obj.feed
        state.comprasPageInfo = obj.pageInfo
      },

      SET_TIPO_CAMBIO: (state, obj) => {
        state.params.codigoActividad.codigoMoneda.tipoCambio = obj?.venta || 500 // BUG: este es un "parche" MIENTRAS se detecta porque a veces no carga el TC

        console.log('[TEST] SET_TIPO_CAMBIO obj', obj)
        console.log('[TEST] SET_TIPO_CAMBIO state.params.codigoActividad.codigoMoneda.tipoCambio', state.params.codigoActividad.codigoMoneda.tipoCambio)
      },

      CHANGE_CURRENCY: (state, { moneda, tipoCambio }) => {
        state.params.codigoActividad.codigoMoneda.id = moneda.id
        state.params.codigoActividad.codigoMoneda.value = moneda.value
        state.params.codigoActividad.codigoMoneda.simbolo = moneda.simbolo

        state.factura.detalleServicio.lineaDetalle.forEach(item => {
          if (!item.codigoMoneda) {
            item.codigoMoneda = {
              value: 'CRC'
            }
          }

          item.precioUnitario = item.codigoMoneda.value === 'CRC' ? item.precioUnitario / tipoCambio : item.precioUnitario * tipoCambio
          item.codigoMoneda = {
            id: moneda.id,
            simbolo: moneda.simbolo,
            value: moneda.value
          }
        })
      },

      SET_REPORTE: (state, obj) => {
        state.reporteVentas = obj.ventas
        state.reporteNotasCredito = obj.notaCredito
        // medioPago sum
        let total = 0
        state.mediosPago = state.reporteVentas.reduce((acc, item) => {
          // el item no debe estar en la lista de NC
          if (item.documento.value === '99' || item.estadoDocumento.value === 3)
            if (!item.notaCredito.length) {
              item.resumenFactura.medioPago?.forEach(m => {
                const nn = acc.find(e => e.annotation === m.annotation)

                if (nn) nn.value += item.resumenFactura.totalComprobante
                else acc.push({ annotation: m.annotation, value: item.resumenFactura.totalComprobante })
              })
              total += item.resumenFactura.totalComprobante
            }

          return acc
        }, [])

        state.mediosPago.forEach(item => (item.porc = (item.value * 100) / total))

        // summary
        // const clientes = new Set(obj.ventas.map(e => (e.receptor ? e.receptor.identificacion.numero : '')).filter(n => n !== ''))
        // const clientesNC = new Set(obj.notaCredito.map(e => (e.receptor ? e.receptor.identificacion.numero : '')).filter(n => n !== ''))
        const totalesVentas = obj.ventas.reduce(
          (acc, item) => {
            if (item.documento.value === '99' || item.estadoDocumento.value === 3) {
              acc.totalVentaNeta += item.resumenFactura.totalVentaNeta
              acc.totalImpuesto += item.resumenFactura.totalImpuesto
              acc.totalOtrosCargos += item.resumenFactura.totalOtrosCargos
              acc.totalComprobante += item.resumenFactura.totalComprobante
              acc.totalCredito +=
                !item.notaCredito.length && item.condicionVenta && item.condicionVenta.annotation === 'Crédito' ? item.resumenFactura.totalComprobante : 0

              acc.documentos += 1
            }
            return acc
          },
          {
            documentos: 0,
            totalVentaNeta: 0,
            totalImpuesto: 0,
            totalOtrosCargos: 0,
            totalComprobante: 0,
            totalCredito: 0
          }
        )
        const totalesNotasCredito = obj.notaCredito.reduce(
          (acc, item) => {
            if (item.documento.value === '993' || item.estadoDocumento.value === 3) {
              acc.totalVentaNeta += item.resumenFactura.totalVentaNeta
              acc.totalImpuesto += item.resumenFactura.totalImpuesto
              acc.totalOtrosCargos += item.resumenFactura.totalOtrosCargos
              acc.totalComprobante += item.resumenFactura.totalComprobante
              acc.documentos += 1
            }
            return acc
          },
          {
            documentos: 0,
            totalVentaNeta: 0,
            totalImpuesto: 0,
            totalOtrosCargos: 0,
            totalComprobante: 0,
            totalOtrosCargos: 0
          }
        )

        // state.totalesVentas[0].clientes = clientes.size
        state.totalesVentas[0].documentos = totalesVentas.documentos
        state.totalesVentas[0].totalVentaNeta = totalesVentas.totalVentaNeta.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesVentas[0].totalImpuesto = totalesVentas.totalImpuesto.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesVentas[0].totalOtrosCargos = totalesVentas.totalOtrosCargos.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesVentas[0].totalComprobante = totalesVentas.totalComprobante.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesVentas[0].totalCredito = totalesVentas.totalCredito

        // state.totalesNotasCredito[0].clientes = clientesNC.size
        state.totalesNotasCredito[0].documentos = totalesNotasCredito.documentos
        state.totalesNotasCredito[0].totalVentaNeta = totalesNotasCredito.totalVentaNeta.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesNotasCredito[0].totalImpuesto = totalesNotasCredito.totalImpuesto.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesNotasCredito[0].totalOtrosCargos = totalesNotasCredito.totalOtrosCargos.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesNotasCredito[0].totalComprobante = totalesNotasCredito.totalComprobante.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

        state.totalGeneral[0].documentos = state.totalesVentas[0].documentos - state.totalesNotasCredito[0].documentos
        state.totalGeneral[0].clientes = state.totalesVentas[0].clientes - state.totalesNotasCredito[0].clientes
        state.totalGeneral[0].totalVentaNeta = (totalesVentas.totalVentaNeta - totalesNotasCredito.totalVentaNeta)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalGeneral[0].totalImpuesto = (totalesVentas.totalImpuesto - totalesNotasCredito.totalImpuesto).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalGeneral[0].totalComprobante = (totalesVentas.totalComprobante - totalesNotasCredito.totalComprobante)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')

        state.totalGeneral[0].totalOtrosCargos = (totalesVentas.totalOtrosCargos - totalesNotasCredito.totalOtrosCargos)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },

      SET_REPORTE_COMPRAS: (state, obj) => {
        state.reporteCompras = obj.compras
        state.reporteNotasCreditoCompras = obj.notaCredito
        // medioPago sum
        // let total = 0
        // state.mediosPago = state.reporteCompras.reduce((acc, item) => {
        //   // el item no debe estar en la lista de NC
        //   if (!item.notaCredito.length) {
        //     item.medioPago.forEach(m => {
        //       const nn = acc.find(e => e.annotation === m.annotation)

        //       if (nn) nn.value += item.resumenFactura.totalComprobante
        //       else acc.push({ annotation: m.annotation, value: item.resumenFactura.totalComprobante })
        //     })
        //     total += item.resumenFactura.totalComprobante
        //   }

        //   return acc
        // }, [])
        // state.mediosPago.forEach(item => (item.porc = (item.value * 100) / total))

        // summary
        // const clientes = new Set(obj.compras.map(e => (e.receptor ? e.receptor.identificacion.numero : '')).filter(n => n !== ''))
        // const clientesNC = new Set(obj.notaCredito.map(e => (e.receptor ? e.receptor.identificacion.numero : '')).filter(n => n !== ''))

        // como la FEC y MR son documentos opcionales, aunque estén rechazados el sistema los suma en cuenta por pagar y reportes.
        const totalesCompras = obj.compras.reduce(
          (acc, item) => {
            acc.totalVentaNeta += item.resumenFactura.totalVentaNeta
            acc.totalImpuesto += item.resumenFactura.totalImpuesto
            acc.totalComprobante += item.resumenFactura.totalComprobante
            acc.totalCredito +=
              !item.notaCredito.length && item.condicionVenta && item.condicionVenta.annotation === 'Crédito' ? item.resumenFactura.totalComprobante : 0

            acc.documentos += 1
            return acc
          },
          {
            documentos: 0,
            totalVentaNeta: 0,
            totalImpuesto: 0,
            totalComprobante: 0,
            totalCredito: 0
          }
        )
        const totalesNotasCreditoCompras = obj.notaCredito.reduce(
          (acc, item) => {
            acc.totalVentaNeta += item.resumenFactura.totalVentaNeta
            acc.totalImpuesto += item.resumenFactura.totalImpuesto
            acc.totalComprobante += item.resumenFactura.totalComprobante
            acc.documentos += 1
            return acc
          },
          {
            documentos: 0,
            totalVentaNeta: 0,
            totalImpuesto: 0,
            totalComprobante: 0
          }
        )

        // state.totalesCompras[0].clientes = clientes.size
        state.totalesCompras[0].documentos = totalesCompras.documentos
        state.totalesCompras[0].totalVentaNeta = totalesCompras.totalVentaNeta.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesCompras[0].totalImpuesto = totalesCompras.totalImpuesto.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesCompras[0].totalComprobante = totalesCompras.totalComprobante.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesCompras[0].totalCredito = totalesCompras.totalCredito

        // state.totalesNotasCreditoCompras[0].clientes = clientesNC.size
        state.totalesNotasCreditoCompras[0].documentos = totalesNotasCreditoCompras.documentos
        state.totalesNotasCreditoCompras[0].totalVentaNeta = totalesNotasCreditoCompras.totalVentaNeta.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesNotasCreditoCompras[0].totalImpuesto = totalesNotasCreditoCompras.totalImpuesto.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalesNotasCreditoCompras[0].totalComprobante = totalesNotasCreditoCompras.totalComprobante.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

        state.totalGeneralCompras[0].documentos = state.totalesCompras[0].documentos - state.totalesNotasCreditoCompras[0].documentos
        state.totalGeneralCompras[0].clientes = state.totalesCompras[0].clientes - state.totalesNotasCreditoCompras[0].clientes
        state.totalGeneralCompras[0].totalVentaNeta = (totalesCompras.totalVentaNeta - totalesNotasCreditoCompras.totalVentaNeta)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalGeneralCompras[0].totalImpuesto = (totalesCompras.totalImpuesto - totalesNotasCreditoCompras.totalImpuesto)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        state.totalGeneralCompras[0].totalComprobante = (totalesCompras.totalComprobante - totalesNotasCreditoCompras.totalComprobante)
          .toFixed(2)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },

      RESET_STATS: state => {
        state.reporteVentasStats = []
        state.reporteVentas = []
      },
      RESET_STATS_COMPRAS: state => {
        // state.reporteVentasStats = []
        state.reporteCompras = []
      },

      SET_REPORTE_STATS: (state, objs) => {
        let total = 0

        state.reporteVentasStats = objs.reduce((acc, item) => {
          const local = new Date(item.createdAt)
          const options = { year: 'numeric', month: 'numeric', day: 'numeric' }
          const localDate = local.toLocaleString('es-CR', options)

          item.item.forEach(f => {
            total += f.montoTotalLinea

            const i = acc.find(prod => prod.nombre === f.nombre)
            if (!i) {
              acc.push({
                nombre: f.nombre,
                transacciones: f.cantidad,
                totalVentaNeta: f.montoTotalLinea,
                receptor: [
                  {
                    id: item.receptor ? item.receptor.id : 'ND',
                    nombre: item.receptor ? item.receptor.nombre : 'ND',
                    transacciones: 1,
                    totalVentaNeta: f.montoTotalLinea
                  }
                ],
                createdAt: [
                  {
                    date: localDate,
                    transacciones: 1,
                    totalVentaNeta: f.montoTotalLinea
                  }
                ]
              })
            } else {
              ;(i.transacciones += f.cantidad), (i.totalVentaNeta += f.montoTotalLinea)
              // receptor

              const id = item.receptor ? item.receptor.id : 'ND'
              const rec = i.receptor.find(r => r.id === id)

              if (!rec) {
                i.receptor.push({
                  id: item.receptor ? item.receptor.id : 'ND',
                  nombre: item.receptor ? item.receptor.nombre : 'ND',
                  transacciones: 1,
                  totalVentaNeta: f.montoTotalLinea
                })
              } else {
                rec.nombre = item.receptor ? item.receptor.nombre : 'ND'
                rec.transacciones += 1
                rec.totalVentaNeta += f.montoTotalLinea
              }

              // createdAt
              const d = i.createdAt.find(day => day.date === localDate)
              if (!d)
                i.createdAt.push({
                  date: localDate,
                  transacciones: 1,
                  totalVentaNeta: f.montoTotalLinea
                })
              else {
                d.transacciones += 1
                d.totalVentaNeta += f.montoTotalLinea
              }
            }
          })

          return acc
        }, [])

        state.reporteVentasStats.forEach(item => {
          item.porc = (item.totalVentaNeta * 100) / total
        })
      },

      UPDATE_FACTURAS: (state, obj) => {
        if (state.facturas.length) {
          const newFactura = state.facturas.find(e => e.id === obj.id)
          if (!newFactura) state.facturas = [obj, ...state.facturas]
          else {
            newFactura.estadoDocumento = obj.estadoDocumento
            newFactura.mail = obj.mail
          }
        } else {
          console.log('la lista de facturas en general no se ha cargado ')
        }
      },

      UPDATE_FACTURAS_CREDITO: (state, obj) => {
        if (state.listaCredito.length) {
          // agrega un delay de 3s para asegurar que la fatura ya esté en la lista.
          setTimeout(() => {
            const newFactura = state.listaCredito.find(e => e.id === obj.id)

            if (newFactura) {
              newFactura.estadoDocumento = obj.estadoDocumento
              newFactura.mail = obj.mail
            }
          }, 3000)
        } else {
          console.log('la lista de credito por cobrar no se ha cargado ')
        }
      },

      RECALC_SALDO_FACTURA_CREDITO: (state, obj) => {
        const doc = state.listaCredito.find(e => e.id === obj.idDoc)
        if (doc) doc.saldo = Number(obj.saldoCredito)
      },

      RECALC_SALDO_FACTURA_CREDITO_COMPRAS: (state, obj) => {
        const doc = state.listaCreditoCompras.find(e => e.id === obj.idDoc)
        if (doc) doc.saldo = Number(obj.saldoCredito)
      },

      UPDATE_TIQUETES: (state, obj) => {
        const newTiquete = state.tiquetes.find(e => e.id === obj.id)
        if (!newTiquete) state.tiquetes = [obj, ...state.tiquetes]
        else {
          newTiquete.estadoDocumento = obj.estadoDocumento
          newTiquete.mail = obj.mail
        }
      },

      UPDATE_FACTURAEXPORTACION: (state, obj) => {
        const newFee = state.facturaExportacion.find(e => e.id === obj.id)
        if (!newFee) state.facturaExportacion = [obj, ...state.facturaExportacion]
        else {
          newFee.estadoDocumento = obj.estadoDocumento
          newFee.mail = obj.mail
        }
      },

      UPDATE_NOTASCREDITO: (state, obj) => {
        const newNotaCredito = state.notasCredito.find(e => e.id === obj.id)
        if (!newNotaCredito) state.notasCredito = [obj, ...state.notasCredito]
        else {
          newNotaCredito.estadoDocumento = obj.estadoDocumento
          newNotaCredito.mail = obj.mail
        }
      },

      UPDATE_PROFORMAS: (state, obj) => {
        const newProforma = state.listaProforma.find(e => e.id === obj._id)

        if (newProforma) newProforma.estadoProforma = obj.estadoProforma

        // if (!newProforma) state.listaProforma = [obj, ...state.listaProforma]
        // else {
        //   newProforma.estadoProforma = obj.estadoProforma
        // }
      },

      UPDATE_MENSAJES_RECEPTOR: (state, obj) => {
        const newMensajeReceptor = state.mensajesReceptor.find(e => e.id === obj.id)
        if (!newMensajeReceptor) state.mensajesReceptor = [obj, ...state.mensajesReceptor]
        else {
          newMensajeReceptor.estadoDocumento = obj.estadoDocumento
          newMensajeReceptor.mail = obj.mail
        }
      },

      UPDATE_COMPRAS: (state, obj) => {
        const newCompra = state.compras.find(e => e.id === obj.id)
        if (!newCompra) state.compras = [obj, ...state.compras]
        else {
          newCompra.estadoDocumento = obj.estadoDocumento
          newCompra.mail = obj.mail
        }
      },

      UPDATE_FACTURAOTROS: (state, obj) => {
        const newOtros = state.facturaOtros.find(e => e.id === obj.id)
        if (!newOtros) state.facturaOtros = [obj, ...state.facturaOtros]
        else {
          newOtros.estadoDocumento = obj.estadoDocumento
          newOtros.mail = obj.mail
        }
      },

      ADD_INFORMACION_REFERENCIA: (state, obj) => {
        const ref = state.factura.informacionReferencia.find(e => e.numero === obj.numero)
        if (ref) {
          ref.tipoDoc = obj.tipoDoc
          ref.fechaEmision = obj.fechaEmision
          ref.codigo = obj.codigo
          ref.razon = obj.razon
        } else state.factura.informacionReferencia.push(obj)

        state.saved = false
      },

      DEL_INFORMACION_REFERENCIA: (state, obj) => {
        state.factura.informacionReferencia = state.factura.informacionReferencia.filter(e => e.numero !== obj.numero)

        state.saved = false
      },

      ADD_OTROS_CARGOS: (state, obj) => {
        const otros = state.factura.otrosCargos.find(e => e.tipoDocumentoOC.id === obj.tipoDocumentoOC.id)
        if (otros) {
          // otros.tipoDocumento = obj.tipoDocumento
          otros.detalle = obj.detalle
          otros.porcentajeOC = obj.porcentajeOC
          otros.montoCargo = obj.montoCargo
        } else state.factura.otrosCargos.push(obj)

        state.saved = false
      },

      DEL_OTROS_CARGOS: (state, obj) => {
        state.factura.otrosCargos = state.factura.otrosCargos.filter(e => e.tipoDocumentoOC.id !== obj.tipoDocumentoOC.id)

        state.saved = false
      },

      ADD_OTROS: (state, obj) => {
        // state.factura.otros = { otroTexto: [obj] } // TODO: esta versión solo almacena 1 "otros"
        const pre = state.factura.otros?.length ? state.factura.otros[0] : null
        state.factura.otros = [{ ...(pre?.otroContenido && { otroContenido: pre.otroContenido }), otroTexto: obj }]

        state.saved = false
      },

      ADD_OTRO_CONTENIDO: (state, obj) => {
        // TODO: esta versión solo almacena 1 "otro contenido"
        const pre = state.factura.otros?.length ? state.factura.otros[0] : null
        state.factura.otros = [{ ...(pre?.otroTexto && { otroTexto: pre.otroTexto }), otroContenido: obj }]

        state.saved = false
      },

      SET_PARAMS: (state, obj) => {
        state.params = obj
      },
      SET_PARAMS_DOCUMENTO: (state, doc) => {
        state.params.codigoActividad.documento = doc
      },
      SET_PARAMS_CLASIFICACION: (state, clasificacion) => {
        state.params.codigoActividad.clasificacion = clasificacion
      },
      SET_PARAMS_CONDICION_VENTA: (state, val) => {
        state.params.condicionVenta = val
      },
      CLEAN_FACTURA: state => {
        state.factura = {
          fechaEmisionOriginal: null,
          original: null,
          pagaCon: '',
          detalleServicio: {
            lineaDetalle: []
          },
          otrosCargos: [],
          resumenFactura: {
            medioPago: [{}], // state.factura.resumenFactura.medioPago, // mantiene el valor de la factura anterior
            totalDescuentos: 0,
            totalImpuesto: 0,
            totalServGravados: 0,
            totalServExonerado: 0,
            totalMercanciasGravadas: 0,
            totalMercExonerada: 0,
            totalGravado: 0,
            totalExonerado: 0,
            totalVenta: 0,
            totalVentaNeta: 0,
            // const TotalIVADevuelto : No aplica en esta version.,
            totalComprobante: 0
          },
          informacionReferencia: [],
          otros: null
        }
        state.exoneracion = null

        state.saved = true
      },
      SET_RECEPTOR: (state, obj) => {
        state.factura.receptor = {
          ...(obj.id && { id: obj.id }),
          ...(obj.crm && { crm: obj.crm }),
          nombre: obj.nombre,
          ...(!obj.identificacionExtranjero && {
            identificacion: {
              tipo: { id: obj?.identificacion?.tipo?.id },
              numero: obj?.identificacion?.numero
            }
          }),
          correoElectronico: obj.correoElectronico,
          ...(obj.telefono?.numTelefono && { telefono: obj.telefono }),
          ...(obj.identificacionExtranjero && { identificacionExtranjero: obj.identificacionExtranjero }),
          ...(obj.categoria && { categoria: obj.categoria }),

          ...(obj.plazoCredito && { plazoCredito: obj.plazoCredito }),
          ...(obj.cuentaContable && { cuentaContable: obj.cuentaContable }),
          ...(obj.limiteCredito && { limiteCredito: obj.limiteCredito }),
          ...(obj.limiteCreditoBlock && { limiteCreditoBlock: obj.limiteCreditoBlock })
        }

        if (obj.waNotifica) {
          state.factura.waNotifica = obj.waNotifica
          state.factura.waTelefonos = obj.waTelefonos
          state.factura.waMensaje = obj.waMensaje
        } else {
          state.factura.waNotifica = false
          state.factura.waTelefonos = []
          state.factura.waMensaje = ''
        }

        state.saved = false
      },
      SET_ACTIVIDAD_RECEPTOR: (state, obj) => {
        state.factura.codigoActividadReceptor = obj
        state.saved = false
      },
      SET_EMISOR_FEC: (state, obj) => {
        // emisor = proveedor de la FEC
        state.factura.emisor = obj
        // {
        //   nombre: obj.nombre,
        //   identificacion: {
        //     tipo: { id: obj.identificacion.tipo.id },
        //     numero: obj.identificacion.numero
        //   },
        //   correoElectronico: obj.correoElectronico
        // }

        state.saved = false
      },
      SET_DETALLE_SERVICIO: (state, obj) => {
        state.factura.detalleServicio = obj
        state.saved = false
      },
      SET_RESUMEN_FACTURA: (state, obj) => {
        state.factura.resumenFactura = obj

        state.saved = false
      },
      ADD_ITEM: (state, obj) => {
        //const clasificacionByCABYS = obj.codigoCABYS?.slice(0, 1) || state.params.codigoActividad.cabys.slice(0, 1)
        //const esProducto = state.codigoProductos.includes(Number(clasificacionByCABYS))

        // TODO: REVISAR CLASIFICACION en facturacion y punto de venta en JIT.
        state.factura.detalleServicio.lineaDetalle.push({
          ...obj,

          numeroLinea: state.factura.detalleServicio.lineaDetalle.length + 1,
          clasificacion: obj.clasificacion || state.params.codigoActividad.clasificacion,
          unidadMedida: obj.unidadMedida?.id ? obj.unidadMedida : { id: state.params.codigoActividad.unidadMedida.id },
          descuento: obj.descuento,

          impuesto: obj.impuesto?.length
            ? obj.impuesto.map(e => {
                return {
                  codigo: { id: e.codigo.id },
                  codigoTarifaIVA: { id: e.codigoTarifa.id },
                  tarifa: e.tarifa,
                  monto: 0 // el monto es recalculado en calc()
                }
              })
            : [
                {
                  codigo: { id: '5efcc43a1feb334e4d49339d' }, // iva
                  codigoTarifaIVA: { id: '5efcc43a1feb334e4d4933a7' }, // tarifa exenta
                  tarifa: 0,
                  monto: 0
                }
              ]
        })

        state.saved = false
      },
      CLEAR_ITEMS: state => {
        state.factura.detalleServicio.lineaDetalle = []

        state.saved = false
      },
      MOD_ITEM: (state, obj) => {
        const item = state.factura.detalleServicio.lineaDetalle.find(e => e.numeroLinea === obj.numeroLinea)

        item.cantidad = obj.cantidad
        item.detalle = obj.detalle
        item.precioUnitario = obj.precioUnitario
        item.codigoCABYS = obj.codigoCABYS

        if (obj.descuento?.length) item.descuento = obj.descuento
        else if (obj.descuento?.length === 0) {
          item.descuento = []
        }
        if (obj.tipoDescuento) {
          item.tipoDescuento = obj.tipoDescuento
        }

        if (obj.cuentaContablePorCobrar) item.cuentaContablePorCobrar = obj.cuentaContablePorCobrar
        if (obj.cuentaContablePorPagar) item.cuentaContablePorPagar = obj.cuentaContablePorPagar

        state.saved = false
      },
      ADD_EXONERACION: (state, obj) => {
        state.exoneracion = {
          tipoDocumentoEX1: { id: obj.tipoDocumentoEX1.id },
          numeroDocumento: obj.numeroDocumento,
          ...(obj.articulo != null && obj.articulo !== '' && { articulo: Number(obj.articulo) }),
          ...(obj.inciso != null && obj.inciso !== '' && { inciso: Number(obj.inciso) }),
          nombreInstitucion: obj.nombreInstitucion,
          fechaEmisionEX: obj.fechaEmisionEX,
          tarifaExonerada: obj.tarifaExonerada,
          montoExoneracion: 0
        }

        state.saved = false
      },
      DELETE_ITEM: (state, obj) => {
        const items = state.factura.detalleServicio.lineaDetalle.filter(e => e.numeroLinea !== obj.numeroLinea)
        let n = 0
        state.factura.detalleServicio.lineaDetalle = items.map(e => {
          n += 1
          return { ...e, numeroLinea: n }
        })

        state.saved = false
      },
      SET_DEFAULT_PARAMS: state => {
        state.params = {}
      },
      SET_CAJA_SESION: (state, obj) => {
        state.cajaSesion = obj
      },
      SET_CUENTA_CONTABLE_IVA_POR_PAGAR: (state, obj) => {
        state.factura.cuentaContableIVAPorPagar = obj
      },
      SET_CUENTA_CONTABLE_IVA_POR_COBRAR: (state, obj) => {
        state.factura.cuentaContableIVAPorCobrar = obj
      }
    }
    this.actions = {
      readCreditoBySearchString: async ({ state }, { searchString, isFEC = false, showContado = false }) =>
        service.readCreditoBySearchString(state.params.emisorId, searchString, isFEC, showContado),

      readDocumentosBySearchString: async ({ state }, { searchString, documento }) =>
        service.readDocumentosBySearchString(state.params.emisorId, searchString, documento),

      readProformaBySearchString: async ({ state }, { searchString }) => service.readProformaBySearchString(state.params.emisorId, searchString),

      readById: async ({ commit, getters }, { storeList, id, documento = '01', forced }) => {
        let doc = null
        if (documento === '01') doc = getters.getFactura(id)
        else if (documento === '03' || documento === '993') doc = getters.getNotaCredito(id)
        else if (documento === '04') doc = getters.getTiquete(id)
        else if (documento === '05' || documento === '06' || documento === '07') doc = getters.getMensajeReceptor(id)
        else if (documento === '08' || documento === '998' || documento === '995') doc = getters.getCompras(id)
        else if (documento === '09') doc = getters.getFacturaExportacion(id)
        else if (documento === '101' || documento === '102' || documento === '103') doc = getters.getSuscripcion(id)
        else if (documento === '99') doc = getters.getFacturaOtros(id)
        else if (documento === '9938') doc = getters.getAnulacionCompras(id)

        if (!doc && !forced) return null

        if (doc?.clave) {
          commit('SET_DOCUMENTO', { storeList, obj: doc })
          console.log('Documento from cache ⏩')
          return true
        }

        return service.readById(id).then(result => {
          if (forced) commit('SET_FULL_DOCUMENTO', { storeList, obj: result })
          else commit('SET_DOCUMENTO', { storeList, obj: result })

          console.log('Documento from DB 😫')

          return true
        })
      },

      clonarFactura: async ({ commit, dispatch, state }, { doc, infoRef, moneda }) => {
        if (moneda?.codigoMoneda?.id) {
          state.params.codigoActividad.codigoMoneda.id = moneda.codigoMoneda.id
          state.params.codigoActividad.codigoMoneda.simbolo = moneda.codigoMoneda.simbolo
          state.params.codigoActividad.codigoMoneda.value = moneda.codigoMoneda.value
        }

        const clone = {
          codigoActividadReceptor: doc.codigoActividadReceptor,
          pagaCon: '',
          detalleServicio: doc.detalleServicio,
          receptor: doc.receptor,
          ...(doc.situacionComprobante && { situacionComprobante: doc.situacionComprobante }),
          otrosCargos: doc.otrosCargos || [],
          resumenFactura: {
            medioPago: [{}],
            totalDescuentos: 0,
            totalImpuesto: 0,
            totalServGravados: 0,
            totalServExonerado: 0,
            totalMercanciasGravadas: 0,
            totalMercExonerada: 0,
            totalGravado: 0,
            totalExonerado: 0,
            totalVenta: 0,
            totalVentaNeta: 0,
            // const TotalIVADevuelto : No aplica en esta version.,
            totalComprobante: 0
          },
          ...(infoRef && { informacionReferencia: doc.informacionReferencia }),
          otros: doc.otros
        }

        commit('CLONAR_FACTURA', clone)
        dispatch('calc')
      },

      readFacturaCreditoById: async ({ commit, state, getters }, { storeList, _id, forced }) => {
        const doc = getters.getFacturaCredito(_id)

        if (!doc && !forced) return null

        if (doc?.clave) {
          commit('SET_DOCUMENTO_CREDITO', { storeList, obj: doc })
          console.log('Documento a Crédito from cache ⏩')

          return true
        }

        return service.readById(_id).then(result => {
          if (!result) return null

          if (forced) commit('SET_FULL_DOCUMENTO_CREDITO', { storeList, obj: result })
          else commit('SET_DOCUMENTO_CREDITO', { storeList, obj: result })

          return true
        })
      },

      readProformaById: async ({ commit, state, getters }, { _id, plazoProforma = null, forced }) => {
        const doc = getters.readProformaById(_id)

        if (!doc && !forced) return null

        if (doc?.detalleServicio) {
          commit('SET_DOCUMENTO_PROFORMA', { obj: doc })
          console.log('Documento proforma from cache ⏩')

          return true
        }

        return service.readById(_id).then(result => {
          if (forced) commit('SET_FULL_DOCUMENTO_PROFORMA', { obj: { ...result, plazoProforma } })
          else commit('SET_DOCUMENTO_PROFORMA', { obj: { ...doc, ...result } })

          console.log('Documento Proforma from DB 😫')

          return true
        })
      },

      readFacturaCreditoComprasById: async ({ commit, state, getters }, { storeList, _id, forced }) => {
        const doc = getters.getFacturaCreditoCompras(_id)

        if (!doc && !forced) return null

        if (doc?.clave) {
          commit('SET_DOCUMENTO_CREDITO', { storeList, obj: doc })
          console.log('Documento a Crédito Compras from cache ⏩')

          return true
        }

        // true = showItemRelated: usado para mostrar el item relacionado con la factura de compras xml
        return service.readById(_id, true).then(result => {
          if (forced) commit('SET_FULL_DOCUMENTO_CREDITO', { storeList, obj: result })
          else commit('SET_DOCUMENTO_CREDITO', { storeList, obj: result })

          console.log('Documento a Crédito Compras from DB 😫')

          return true
        })
      },

      readByIdFromPago: async ({ commit, getters }, { storeList, _id }) => {
        const doc = getters.getFacturaCredito(_id) // la lista de pagos abre los documentos que tambien fueron cargados en la lista de credito (mis facturas)

        if (doc?.clave) {
          commit('SET_DOCUMENTO_PAGO', { storeList, obj: doc })
          console.log('Documento Pago from cache ⏩')

          return true
        }

        return service.readById(_id).then(result => {
          commit('SET_DOCUMENTO_PAGO', { storeList, obj: result })
          commit('SET_FULL_DOCUMENTO_CREDITO', { storeList, obj: result })

          console.log('Documento Pago from DB 😫')

          return true
        })
      },

      // muestra la lista completa de comprobantes del emisor sin importar el tipo de documento.
      readByEmisor: ({ commit, state, dispatch }, { limit = 10, refresh = false, restart = false }) => {
        if (restart) {
          state.facturas = []
          state.facturasPageInfo = {}
        }

        if (state.facturas.length === 0 || refresh)
          service.readByEmisor(state.params.emisorId, state.facturasPageInfo.nextPageCursor, limit).then(result => {
            commit('SET_FACTURAS', result)
            if (!state.isListening) {
              state.isListening = true

              // FIXME: solo carga cuando el estado es 1 o 2 y si es diferente de 99
              dispatch('subscriptionNewFactura')
            }
          })
      },

      readDocumentosCredito: async ({ commit, state, dispatch }, { restart = false, limit = 10, filter = null, isFEC = false, showContado = false }) => {
        if (restart) {
          if (!isFEC) await dispatch('resetListaCredito')
          else await dispatch('resetListaCreditoCompras')
        }

        return service
          .readDocumentosCredito(
            state.params.emisorId,
            state[!isFEC ? 'listaCreditoPageInfo' : 'listaCreditoComprasPageInfo'].nextPageCursor,
            limit,
            filter,
            isFEC,
            showContado
          )
          .then(result => {
            if (!isFEC) {
              commit('SET_LISTA_CREDITO', result)

              if (!state.isListening) {
                state.isListening = true
                dispatch('subscriptionFacturaCredito')
              }
            } else commit('SET_LISTA_CREDITO_COMPRAS', result)
          })
      },

      readDocumentosProforma: async ({ commit, state, dispatch }, { restart = false, limit = 10, filter = null }) => {
        if (restart) {
          await dispatch('resetListaProforma')
        }

        return service.readDocumentosProforma(state.params.emisorId, state.listaProformaPageInfo.nextPageCursor, limit, filter).then(result => {
          commit('SET_LISTA_PROFORMA', result)

          // if (!state.isListening) {
          //   state.isListening = true
          //   dispatch('subscriptionxxx')
          // }
        })
      },

      resetList: ({ state }, documento) => {
        if (documento === '01') {
          state.facturas = []
          state.facturasPageInfo = {}
          state.totalRegistrosFe = 0
        }
        if (documento === '03') {
          state.notasCredito = []
          state.notasCreditoPageInfo = {}
          state.totalRegistrosNc = 0
        }
        if (documento === '04') {
          state.tiquetes = []
          state.tiquetesPageInfo = {}
          state.totalRegistrosTe = 0
        }
        if (documento === '05') {
          state.mensajesReceptor = []
          state.mensajesReceptorPageInfo = {}
          state.totalRegistrosMr = 0
          state.totalRegistrosCobrar = 0
        }
        if (documento === '08') {
          state.compras = []
          state.comprasPageInfo = {}
          state.totalRegistrosFec = 0
        }
        if (documento === '09') {
          state.facturaExportacion = []
          state.facturaExportacionPageInfo = {}
          state.totalRegistrosFee = 0
        }
        if (documento === '99') {
          state.facturaOtros = []
          state.facturaOtrosPageInfo = {}
          state.totalRegistrosOtros = 0
        }
        if (documento === '101' || documento === '102' || documento === '103') {
          state.suscripcion = []
          state.suscripcionPageInfo = {}
        }
      },

      resetListaCredito: ({ state }) => {
        state.listaCredito = []
        state.listaCreditoPageInfo = {}
      },

      resetListaCreditoCompras: ({ state }) => {
        state.listaCreditoCompras = []
        state.listaCreditoComprasPageInfo = {}
      },

      resetListaProforma: ({ state }) => {
        state.listaProforma = []
        state.listaProformaPageInfo = {}
      },

      // eslint-disable-next-line consistent-return
      readDocumentosEmisor: async ({ commit, state, dispatch }, { restart = false, documento = '01', limit = 10, filter = null }) => {
        if (restart) await dispatch('resetList', documento)

        if (documento === '01') {
          return service.readByEmisor(state.params.emisorId, state.facturasPageInfo.nextPageCursor, limit, documento, filter).then(result => {
            commit('SET_FACTURAS', result)
            if (!state.isListening) {
              state.isListening = true
              dispatch('subscriptionNewFactura')
            }
          })
        }

        if (documento === '03') {
          return service.readByEmisor(state.params.emisorId, state.notasCreditoPageInfo.nextPageCursor, limit, documento, filter).then(result => {
            commit('SET_NOTASCREDITO', result)
            if (!state.isListening) {
              state.isListening = true
              dispatch('subscriptionNewFactura')
            }
          })
        }

        if (documento === '04') {
          return service.readByEmisor(state.params.emisorId, state.tiquetesPageInfo.nextPageCursor, limit, documento, filter).then(result => {
            commit('SET_TIQUETES', result)

            if (!state.isListening) {
              state.isListening = true
              dispatch('subscriptionNewFactura')
            }
          })
        }

        if (documento === '05' || documento === '06' || documento === '07') {
          return service.readByEmisor(state.params.emisorId, state.mensajesReceptorPageInfo.nextPageCursor, limit, documento, filter).then(result => {
            commit('SET_MENSAJES_RECEPTOR', result)
            if (!state.isListening) {
              state.isListening = true
              dispatch('subscriptionNewFactura')
            }
          })
        }

        if (documento === '08' || documento === '998' || documento === '995') {
          return service.readByEmisor(state.params.emisorId, state.comprasPageInfo.nextPageCursor, limit, documento, filter).then(result => {
            commit('SET_COMPRAS', result)

            if (!state.isListening) {
              state.isListening = true
              dispatch('subscriptionNewFactura')
            }
          })
        }

        if (documento === '09') {
          return service.readByEmisor(state.params.emisorId, state.facturaExportacionPageInfo.nextPageCursor, limit, documento, filter).then(result => {
            commit('SET_FACTURAEXPORTACION', result)

            if (!state.isListening) {
              state.isListening = true
              dispatch('subscriptionNewFactura')
            }
          })
        }

        if (documento === '99') {
          return service.readByEmisor(state.params.emisorId, state.facturaOtrosPageInfo.nextPageCursor, limit, documento, filter).then(result => {
            commit('SET_FACTURAOTROS', result)

            if (!state.isListening) {
              state.isListening = true
              dispatch('subscriptionNewFactura')
            }
          })
        }

        if (documento === '101' || documento === '102' || documento === '103') {
          return service.readByEmisor(state.params.emisorId, state.suscripcionPageInfo.nextPageCursor, limit, documento, filter).then(result => {
            commit('SET_SUSCRIPCION', result)

            // if (!state.isListening) {
            //   state.isListening = true
            //   // dispatch('subscriptionNewFactura') NO TIENE ESTADO DE MH
            // }
          })
        }

        if (documento === '9938') {
          return service.readByEmisor(state.params.emisorId, state.anulacionComprasPageInfo.nextPageCursor, limit, documento, filter).then(result => {
            commit('SET_ANULACIONCOMPRAS', result)

            // if (!state.isListening) {
            //   state.isListening = true
            //   dispatch('subscriptionNewFactura')
            // }
          })
        }
      },

      readByDateRange: async ({ commit, dispatch, state }, { inicio, final, documento = null }) => {
        await dispatch('resetList', documento)

        // eslint-disable-next-line no-undef
        return service.readByDateRange(state.params.emisorId, inicio, final, documento).then(result => {
          if (documento === '01') commit('SET_FACTURAS_BY_DATE', result)
          if (documento === '03') commit('SET_NOTASCREDITO_BY_DATE', result)
          if (documento === '04') commit('SET_TIQUETES_BY_DATE', result)
          if (documento === '05' || documento === '06' || documento === '07') commit('SET_MENSAJES_RECEPTOR_BY_DATE', result)
          if (documento === '08' || documento === '998' || documento === '995') commit('SET_COMPRAS_BY_DATE', result)
          if (documento === '09') commit('SET_FACTURAEXPORTACION_BY_DATE', result)
          if (documento === '99') commit('SET_FACTURAOTROS_BY_DATE', result)
          if (documento === '101' || documento === '102' || documento === '103') commit('SET_SUSCRIPCION_BY_DATE', result)
        })
      },

      readCreditoByDateRange: async ({ commit, dispatch, state }, { inicio, final, isFEC = false, showContado = false }) => {
        if (!isFEC) await dispatch('resetListaCredito')
        else await dispatch('resetListaCreditoCompras')

        // eslint-disable-next-line no-undef
        return service.readCreditoByDateRange(state.params.emisorId, inicio, final, isFEC, showContado).then(result => {
          if (!isFEC) commit('SET_LISTA_CREDITO', result)
          else commit('SET_LISTA_CREDITO_COMPRAS', result)
        })
      },

      readProformaByDateRange: async ({ commit, dispatch, state }, { inicio, final, isFEC = false }) => {
        dispatch('resetListaProforma')

        // eslint-disable-next-line no-undef
        return service.readProformaByDateRange(state.params.emisorId, inicio, final).then(result => {
          commit('SET_LISTA_PROFORMA', result)
        })
      },

      subscriptionNewFactura: ({ commit, state }) =>
        service.subscriptionNewFactura(state.params.emisorId, result => {
          if (!result) return null

          if (result.documento.value === '01') commit('UPDATE_FACTURAS', result)
          if (result.documento.value === '03') commit('UPDATE_NOTASCREDITO', result)
          if (result.documento.value === '04') commit('UPDATE_TIQUETES', result)
          if (result.documento.value === '05' || result.documento.value === '06' || result.documento.value === '07') commit('UPDATE_MENSAJES_RECEPTOR', result)
          if (result.documento.value === '08' || result.documento.value === '998' || result.documento.value === '995') commit('UPDATE_COMPRAS', result)
          if (result.documento.value === '09') commit('UPDATE_FACTURAEXPORTACION', result)
          if (result.documento.value === '99') commit('UPDATE_FACTURAOTROS', result)
        }),

      subscriptionFacturaCredito: ({ commit, state }) => {
        service.subscriptionNewFactura(state.params.emisorId, result => commit('UPDATE_FACTURAS_CREDITO', result))
      },

      readParams: ({ commit, dispatch, state }, refresh = false) =>
        dispatch('facturacion/emisorStore/readByUserId', refresh, {
          root: true
        }).then(async emisor => {
          // si ya tiene params de factura cargados, no recarga desde los params por defecto del emisor. Esto para no cambiar la configuración que se tiene en memoria.
          if (state.params.emisorId && !refresh) return true

          return commit('SET_PARAMS', {
            situacionComprobante: { id: null },

            condicionVenta: emisor.codigoActividad[0].condicionVenta ?? { id: null, annotation: '' },
            plazoCredito: emisor.codigoActividad[0].plazoCredito ?? null,
            plazoProforma: null,
            medioPago: emisor.codigoActividad[0].medioPago ?? { id: null, value: '' },

            emisorId: emisor.id,
            nombre: emisor.nombre,
            identificacion: emisor.identificacion,
            nombreComercial: emisor.nombreComercial,
            local: emisor.local,
            ubicacion: emisor.ubicacion,
            correoElectronico: emisor.correoElectronico,

            codigoActividad: {
              documento: emisor.codigoActividad[0].documento,
              codigoActividad: emisor.codigoActividad[0].codigoActividad,
              clasificacion: emisor.codigoActividad[0].clasificacion,
              cabys: emisor.codigoActividad[0].cabys,
              modoivaIncluido: emisor.codigoActividad[0].modoivaIncluido,
              editarServicios: emisor.codigoActividad[0].editarServicios,
              editarPrecios: emisor.codigoActividad[0].editarPrecios,
              modoLibre: emisor.codigoActividad[0].modoLibre,
              codigoMoneda: {
                id: emisor.codigoActividad[0].codigoMoneda.id,
                value: emisor.codigoActividad[0].codigoMoneda.value,
                simbolo: emisor.codigoActividad[0].codigoMoneda.simbolo,
                tipoCambio: state?.params?.codigoActividad?.codigoMoneda?.tipoCambio ?? 1
              },
              unidadMedida: { id: emisor.codigoActividad[0].unidadMedida.id },
              codigo: {
                id: emisor.codigoActividad[0].codigo.id,
                value: emisor.codigoActividad[0].codigo.value
              },
              codigoTarifa: { id: emisor.codigoActividad[0].codigoTarifa.id },
              tarifa: emisor.codigoActividad[0].tarifa
            }
          })
        }),

      addItem: ({ commit, dispatch }, item) => {
        commit('ADD_ITEM', item)
        dispatch('calc')
      },

      addExoneracion: ({ commit, dispatch, rootState }, item) => {
        const instList = rootState.facturacion?.types?.institucionExoneracion?.list || []
        const searchTarget = String(item.nombreInstitucion || '').trim().toLowerCase()
        const found = instList.find(
          ex =>
            String(ex.annotation || '').trim().toLowerCase() === searchTarget ||
            String(ex.value || '').trim().toLowerCase() === searchTarget
        )

        if (!found) {
          throw new Error(`La institución "${item.nombreInstitucion || 'N/A'}" no se encuentra en el catálogo de exoneraciones.`)
        }

        const nombreInstitucion = found.value

        // agrega el codigo de la institucion como nombre.
        commit('ADD_EXONERACION', { ...item, nombreInstitucion })
        dispatch('calc')
      },

      modItem: ({ commit, dispatch }, item) => {
        commit('MOD_ITEM', item)
        dispatch('calc')
      },

      deleteItem: ({ commit, dispatch }, item) => {
        commit('DELETE_ITEM', item)
        dispatch('calc')
      },

      changeCurrency: ({ commit, dispatch, state, rootState }) => {
        const tipoCambio = state.params.codigoActividad.codigoMoneda.tipoCambio

        const moneda =
          state.params.codigoActividad.codigoMoneda.value === 'CRC'
            ? rootState.facturacion.types.moneda.list.find(item => item.value === 'USD')
            : rootState.facturacion.types.moneda.list.find(item => item.value === 'CRC')

        // delete moneda.pais
        const { pais, ...monedaRest } = moneda
        commit('CHANGE_CURRENCY', { moneda: monedaRest, tipoCambio })
        dispatch('calc')
      },

      calc({ commit, state, rootGetters }) {
        const resumenFactura = {
          medioPago: state.factura.resumenFactura.medioPago,
          totalDescuentos: 0,
          totalServGravados: 0,
          totalServExonerado: 0,
          totalServExentos: 0,
          totalMercanciasGravadas: 0,
          totalMercanciasExentas: 0,
          totalMercExonerada: 0,
          totalImpuesto: 0,
          totalGravado: 0,
          totalExonerado: 0,
          totalExento: 0,
          totalVenta: 0,
          totalVentaNeta: 0,
          // TotalIVADevuelto: 0,
          totalOtrosCargos: 0,
          totalComprobante: 0
        }

        const detalleServicio = {}

        // si el receptor tiene exoneracion, agrega a las lineas que tienen cabys valido.
        if (state.exoneracion) {
          const cabysDocExoneracion = rootGetters['exoneracion/getCabys']

          // si no tiene cabys, agrega todas las lineas.
          const itemCabys = cabysDocExoneracion?.length
            ? state.factura.detalleServicio.lineaDetalle?.filter(item => cabysDocExoneracion.includes(item.codigoCABYS)) || []
            : state.factura.detalleServicio.lineaDetalle

          for (const item of itemCabys) {
            item.impuesto?.forEach(iva => {
              iva.exoneracion = { ...state.exoneracion }
            })
          }
        }

        detalleServicio.lineaDetalle = state.factura.detalleServicio.lineaDetalle.map(lineaDetalle => {
          lineaDetalle.precioUnitario = Number(lineaDetalle.precioUnitario.toFixed(5))
          lineaDetalle.codigoCABYS = !lineaDetalle.codigoCABYS ? state.params.codigoActividad.cabys : lineaDetalle.codigoCABYS
          lineaDetalle.cantidad = Number(lineaDetalle.cantidad?.toFixed(3) ?? 1)

          if (!lineaDetalle.unidadMedida)
            lineaDetalle.unidadMedida = {
              id: state.params.codigoActividad.unidadMedida.id
            }

          lineaDetalle.montoTotal = Number((lineaDetalle.precioUnitario * lineaDetalle.cantidad).toFixed(5))

          // Descuento según CRM
          // TODO: alerta de doble descuento: crm + inventario
          // TODO: alerta de descuento mayor a 100%
          // TODO: alerta de descuento ABSOLUTO mayor a la factura

          const descuentoLinea = lineaDetalle.descuento
            ? lineaDetalle.descuento.reduce((total, { montoDescuento }) => Number((total + montoDescuento).toFixed(5)), 0)
            : 0

          // totalDescuentos
          resumenFactura.totalDescuentos += descuentoLinea

          // sub total
          lineaDetalle.subtotal = Number((lineaDetalle.montoTotal - descuentoLinea).toFixed(5))

          const { montoImpuestosLinea, montoExoneracionLinea } = lineaDetalle.impuesto.reduce(
            (impuesto, itemImpuesto) => {
              // factorIVA= // TODO: esta versión no contempla factor iva para venta de usados.
              // monto del impuesto.
              // TODO: alquiler. < 660.000 no paga iva. Se debe seleccionar la tarifa 0% exento en PARAMS.
              // if (state.factura.codigoActividad.codigoActividad.value === '701001') {
              //   if (lineaDetalle.subtotal < 660000) {
              //     itemImpuesto.tarifa = 0
              //     itemImpuesto.codigoActividad.codigoTarifa = 'value 01' // "Tarifa 0% (Exento)"
              //     itemImpuesto.monto = 0
              //   }
              // } else

              itemImpuesto.monto = Number((lineaDetalle.subtotal * (itemImpuesto.tarifa.toFixed(2) / 100)).toFixed(5))

              // sumatoria de impuestos de la linea.
              impuesto.montoImpuestosLinea += itemImpuesto.monto
              // exoneraciones
              let porcentajeExoneracionLinea = 0
              if (itemImpuesto.exoneracion) {
                porcentajeExoneracionLinea = Number(itemImpuesto.exoneracion.tarifaExonerada.toFixed(2))

                itemImpuesto.exoneracion.montoExoneracion = Number(((porcentajeExoneracionLinea / 100) * lineaDetalle.subtotal).toFixed(5))

                impuesto.montoExoneracionLinea = Number((impuesto.montoExoneracionLinea + itemImpuesto.exoneracion.montoExoneracion).toFixed(5))
              }

              // TODO: en el api se valida la clasificacion TRANSACCION, aqui se debería considerar tambien?
              if (['servicio', 'gasto', 'costo fijo', 'costo variable'].includes(lineaDetalle.clasificacion)) {
                resumenFactura.totalServGravados += itemImpuesto.monto
                  ? Number(
                      (
                        (1 - porcentajeExoneracionLinea / 100 / (itemImpuesto.tarifa === 0 ? 1 : itemImpuesto.tarifa.toFixed(2) / 100)) *
                        lineaDetalle.montoTotal
                      ).toFixed(5)
                    )
                  : 0
                //resumenFactura.totalServExentos = 0
                resumenFactura.totalServExonerado += Number(
                  (
                    (porcentajeExoneracionLinea / 100 / (itemImpuesto.tarifa === 0 ? 1 : itemImpuesto.tarifa.toFixed(2) / 100)) *
                    lineaDetalle.montoTotal
                  ).toFixed(5)
                )
              } else if (['producto', 'activo'].includes(lineaDetalle.clasificacion)) {
                resumenFactura.totalMercanciasGravadas += itemImpuesto.monto
                  ? Number(
                      (
                        (1 - porcentajeExoneracionLinea / 100 / (itemImpuesto.tarifa === 0 ? 1 : itemImpuesto.tarifa.toFixed(2) / 100)) *
                        lineaDetalle.montoTotal
                      ).toFixed(5)
                    )
                  : 0
                //resumenFactura.totalMercanciasExentas = 0
                resumenFactura.totalMercExonerada += Number(
                  (
                    (porcentajeExoneracionLinea / 100 / (itemImpuesto.tarifa === 0 ? 1 : itemImpuesto.tarifa.toFixed(2) / 100)) *
                    lineaDetalle.montoTotal
                  ).toFixed(5)
                )
              }

              return impuesto
            },
            {
              montoImpuestosLinea: 0,
              montoExoneracionLinea: 0
            }
          )

          lineaDetalle.impuestoNeto = Number((montoImpuestosLinea - montoExoneracionLinea).toFixed(5))
          lineaDetalle.montoTotalLinea = Number((lineaDetalle.subtotal + lineaDetalle.impuestoNeto).toFixed(5))
          // impuesto total
          resumenFactura.totalImpuesto += Number(lineaDetalle.impuestoNeto.toFixed(5))

          lineaDetalle.baseImponible = lineaDetalle.subtotal

          // calcula sevicios y producto exentos cuando no hay impuestos.
          const tieneTarifaCero = lineaDetalle.impuesto?.some(impuesto => impuesto.tarifa === 0)
          if (tieneTarifaCero || !lineaDetalle.impuesto?.length) {
            if (['servicio', 'gasto', 'costo fijo', 'costo variable'].includes(lineaDetalle.clasificacion)) {
              // resumenFactura.totalServGravados -= Number(lineaDetalle.montoTotal.toFixed(5))
              resumenFactura.totalServExentos += Number(lineaDetalle.montoTotal.toFixed(5))
              resumenFactura.totalServExonerado = 0 // si no tiene impuestos, no aplica exoneraciones.
            } else if (['producto', 'activo'].includes(lineaDetalle.clasificacion)) {
              // resumenFactura.totalMercanciasGravadas -= Number(lineaDetalle.montoTotal.toFixed(5))
              resumenFactura.totalMercanciasExentas += Number(lineaDetalle.montoTotal.toFixed(5))
              resumenFactura.totalMercExonerada = 0 // si no tiene impuestos, no aplica exoneraciones.
            }
          }

          return lineaDetalle
        })
        // redondea descuentos
        resumenFactura.totalDescuentos = Number(resumenFactura.totalDescuentos.toFixed(5))

        // otros cargos
        resumenFactura.totalOtrosCargos = state.factura.otrosCargos ? state.factura.otrosCargos.reduce((total, item) => total + item.montoCargo, 0) : 0

        // resumen factura
        resumenFactura.totalImpuesto = Number(resumenFactura.totalImpuesto.toFixed(5))

        resumenFactura.totalServGravados = Number(resumenFactura.totalServGravados.toFixed(5))
        resumenFactura.totalServExonerado = Number(resumenFactura.totalServExonerado.toFixed(5))
        resumenFactura.totalServExentos = Number(resumenFactura.totalServExentos.toFixed(5))

        resumenFactura.totalMercanciasGravadas = Number(resumenFactura.totalMercanciasGravadas.toFixed(5))
        resumenFactura.totalMercExonerada = Number(resumenFactura.totalMercExonerada.toFixed(5))
        resumenFactura.totalMercanciasExentas = Number(resumenFactura.totalMercanciasExentas.toFixed(5))

        resumenFactura.totalGravado = Number((resumenFactura.totalMercanciasGravadas + resumenFactura.totalServGravados).toFixed(5))

        resumenFactura.totalExonerado = Number((resumenFactura.totalMercExonerada + resumenFactura.totalServExonerado).toFixed(5))
        resumenFactura.totalExento = Number((resumenFactura.totalMercanciasExentas + resumenFactura.totalServExentos).toFixed(5))

        resumenFactura.totalVenta = Number((resumenFactura.totalGravado + resumenFactura.totalExento + resumenFactura.totalExonerado).toFixed(5))
        resumenFactura.totalVentaNeta = Number((resumenFactura.totalVenta - resumenFactura.totalDescuentos).toFixed(5))
        // const TotalIVADevuelto = No aplica en esta version.
        resumenFactura.totalComprobante = Number(
          (resumenFactura.totalVentaNeta + resumenFactura.totalImpuesto + resumenFactura.totalOtrosCargos) /* - totalIVADevuelto */
            .toFixed(5)
        )

        commit('SET_DETALLE_SERVICIO', detalleServicio)
        commit('SET_RESUMEN_FACTURA', resumenFactura)
      },

      cleanFactura({ commit }) {
        commit('CLEAN_FACTURA')
        commit('facturacion/receptorStore/RESET_RECEPTOR', {}, { root: true })
        commit('facturacion/receptorStore/SET_RECEPTORES', [], { root: true })
      },

      readTipoCambioBCCR: async ({ commit, state }) => {
        if (state.params?.codigoActividad?.codigoMoneda?.tipoCambio > 1) return true

        return service
          .readTipoCambioBCCR()
          .then(result => commit('SET_TIPO_CAMBIO', result))
          .catch(() => commit('SET_TIPO_CAMBIO', { venta: 500, catchError: true }))
      },

      generarReporte: async ({ commit, state }, { filter, showNC, showRechazadas, showOtrosCargos }) => {
        return service.generarReporte(state.params.emisorId, filter, showNC, showRechazadas, showOtrosCargos).then(result => commit('SET_REPORTE', result))
      },

      generarReporteCompras: async ({ commit, rootGetters }, { filter, showNC, showRechazadas }) => {
        return service
          .generarReporteCompras(await rootGetters['facturacion/emisorStore/get_Id'], filter, showNC, showRechazadas)
          .then(result => commit('SET_REPORTE_COMPRAS', result))
      },

      crearEstadisticas: async ({ commit, state }, { filter }) => {
        return service.crearEstadisticas(state.params.emisorId, filter).then(result => commit('SET_REPORTE_STATS', result))
      },

      setCondicionVenta({ commit, rootGetters }, val) {
        const condicion = rootGetters['facturacion/types/condicionVenta/getValues'](val)

        return commit('SET_PARAMS_CONDICION_VENTA', condicion)
      },

      updateDocumentosCreditoMR({ dispatch, state }) {
        if (state.listaCreditoCompras.length) {
          dispatch('readDocumentosCredito', {
            restart: true,
            limit: 10,
            filter: null,
            isFEC: true,
            showContado: localStorage.getItem('showContadoPagar') === 'true'
          })
        }
      },

      create({ commit, state, dispatch, rootGetters, rootState }, payload) {
        const {
          inventario = false,
          subscription = '',
          docId = null,
          creaClave = true,
          cuentaContablePago = null,
          forceAvoidOrder = null,
          condicionVenta = null,
          plazoCredito = null,
          isFec = false,
          accounting = false,
          autoPago = true,
          overrideEmisor = false
        } = payload

        const documento = !isFec ? { id: docId || subscription || state.params.codigoActividad.documento.id } : state.factura.documento

        // elimina campos innecesarios
        state.factura.detalleServicio.lineaDetalle.forEach(linea => {
          ;['tipoDescuento', 'bajoDemanda', 'stock', 'stockState', 'codigoRapido', 'codigoMoneda', 'tipo', 'attributes'].forEach(field => delete linea[field])

          if (linea.item.nombre !== undefined) {
            delete linea.item.nombre
          }
          if (linea.cuentaContablePorPagar) {
            delete linea.cuentaContablePorPagar.code
            delete linea.cuentaContablePorPagar.name
          }
          if (linea.cuentaContablePorCobrar) {
            delete linea.cuentaContablePorCobrar.code
            delete linea.cuentaContablePorCobrar.name
          }

          // excluido para FEE Y FEC
          if (!['5efcc43a1feb334e4d492e25', '5efcc43a1feb334e4d492e24'].includes(documento.id)) {
            linea.impuestoAsumidoEmisorFabrica = 0
          }
        })

        if (state.factura.receptor?.limiteCredito >= 0) {
          delete state.factura.receptor.limiteCreditoBlock
          delete state.factura.receptor.limiteCredito
        }

        // datos de la factura
        state.factura = {
          ...state.factura,

          // si es una fec debe tomar el tipo de documento asignado segun el modo inventario
          documento,
          situacionComprobante: { id: state.params.situacionComprobante?.id || '5efcc43a1feb334e4d4934db' }, // 5efcc43a1feb334e4d4934db Normal.
          codigoActividad: {
            id: state.params.codigoActividad.codigoActividad.id
          },
          local: { id: state.params.local[0].id, numero: state.params.local[0].numero || '001' },
          terminal: { id: state.params.local[0].terminal[0].id, numero: state.params.local[0].terminal[0].numero || '00001' },
          emisor: overrideEmisor // overrideEmisor se usa en pago recurrente cuando el emisor viene listo en el documento
            ? state.factura.emisor
            : !isFec
            ? {
                ...state.factura.emisor,
                id: state.params.emisorId,
                nombre: state.params.nombre,
                identificacion: state.params.identificacion,
                ...(state.params.nombreComercial && { nombreComercial: state.params.nombreComercial }),
                ubicacion: {
                  provincia: { id: state.params.ubicacion.provincia.id },
                  canton: { id: state.params.ubicacion.canton.id },
                  distrito: { id: state.params.ubicacion.distrito.id },
                  otrasSenas: state.params.ubicacion.otrasSenas
                },
                correoElectronico: state.params.correoElectronico
              }
            : state.factura.emisor,
          // receptor: {} agregado en modal.receptor.
          condicionVenta: condicionVenta || state.factura.condicionVenta || { id: state.params.condicionVenta.id },
          // TODO: AGREGAR EL PLAZO credito solo si la factura es a crédito.
          plazoCredito: plazoCredito ? Number(plazoCredito) : Number(state.params.plazoCredito),
          plazoProforma: state.params.plazoProforma ? Number(state.params.plazoProforma) : null,

          // detalleServicio: {} agregado en la tabla de items.
          // informacionReferencia: [] agregado en modal informacionReferencia
          // agrega el resto de la factura.
          otrosCargos: state.factura.otrosCargos
            ? state.factura.otrosCargos.map(e => ({
                ...e,
                porcentajeOC: Number(e.porcentajeOC)
              }))
            : [],

          // agrega codigo de la moneda al resumen factura.
          resumenFactura: {
            ...state.factura.resumenFactura,

            codigoTipoMoneda: {
              codigoMoneda: {
                id: state.params.codigoActividad.codigoMoneda.id
              },
              tipoCambio:
                state.params.codigoActividad.codigoMoneda.value !== 'CRC'
                  ? Number(parseFloat(state.params.codigoActividad.codigoMoneda.tipoCambio).toFixed(5))
                  : 1
            }
          }
        }

        // si es SUSCRIPCION, cambia la factura a credito y medio de pago otros
        if (subscription) {
          state.factura.resumenFactura.medioPago = [
            {
              id: '5efcc43a1feb334e4d493337', // transferencia
              tipoMedioPago: '04',
              annotation: 'Transferencia - depósito bancario',
              totalMedioPago: state.factura.resumenFactura.totalComprobante
            }
          ]
          // FIXME: las suscripciones no deben ser siempre a crédito.
          state.factura.condicionVenta = { id: rootGetters['facturacion/types/condicionVenta/get_Id']('02') } // credito
          state.factura.plazoCredito = Number(state.params.plazoCredito || 3)
        }

        // si es FEE elimina la exoneracion
        if (state.params.codigoActividad.documento.value === '09') {
          ;['totalServExonerado', 'totalMercExonerada', 'totalExonerado'].forEach(field => delete state.factura.resumenFactura[field])
        }

        // Limpia campos innecesarios en receptor y emisor
        ;['categoria', 'crm', 'plazoCredito'].forEach(field => {
          if (state.factura.receptor) delete state.factura.receptor[field]
          if (state.factura.emisor) delete state.factura.emisor[field]
        })

        const { cuentaContableIVAPorPagar, cuentaContableIVAPorCobrar } = state.factura

        if (!cuentaContableIVAPorPagar) delete state.factura.cuentaContableIVAPorPagar
        if (!cuentaContableIVAPorCobrar) delete state.factura.cuentaContableIVAPorCobrar

        // v4.4 codigoActividadEmisor & codigoActividadReceptor
        // el codigoActividadReceptor en una FE se agrega directamente en SET_ACTIVIDAD_RECEPTOR
        if (isFec) {
          state.factura.codigoActividadReceptor = state.params.codigoActividad?.codigoActividad?.value || '000000'
          // referencia al documento original de la compra.
          state.factura.informacionReferencia = [
            {
              // comprobante aportado por contribuyente de regimen especial, o 16 Comprobante de proveedor no domiciliado.
              tipoDocIR: {
                id: '684270729fdf44f9dcf7e290',
                value: '14'
              },
              numero: state.factura.original || '0000',
              fechaEmisionIR: state.factura.fechaEmisionOriginal,
              codigo: {
                // otro documento.
                id: '5efcc43a1feb334e4d4934da',
                value: '99'
              },
              tipoDocRefOTRO: 'Referencia a un documento de proveedor no domiciliado o regimen especial',
              codigoReferenciaOTRO: 'Comprobante de proveedor no domiciliado o regimen especial',
              razon: 'Comprobante de regimen simplificado'
            }
          ]
        } else state.factura.codigoActividadEmisor = state.params.codigoActividad?.codigoActividad?.value || '000000'

        // si es una TE o es vacio, elimina el codigoActividadReceptor
        if (state.factura.codigoActividadReceptor === '' || documento.id === '5efcc43a1feb334e4d492e20') delete state.factura.codigoActividadReceptor

        // eslint-disable-next-line no-console
        console.log('Factura a enviar 🚀 :>> ', JSON.stringify(state.factura, null, 2))

        // forceAvoidOrder, evita que se emita una orden de venta. Si es null, hace el análisis.
        const productionOrder =
          forceAvoidOrder === null
            ? state.params.codigoActividad.documento.value !== '08' &&
              state.params.codigoActividad.documento.value !== '05' &&
              Session.user.profile !== 'COMMUNITY' &&
              Session.user.profile !== 'FACTURA' &&
              !state.params.codigoActividad.modoLibre
            : false
            ? true
            : false

        console.log('productionOrder', productionOrder)
        console.log('forceAvoidOrder', forceAvoidOrder)
        console.log('inventario', inventario)
        console.log('accounting :>> ', accounting)
        console.log('doc', state.params.codigoActividad.documento.value)

        // agrega el id de la caja
        if (state.cajaSesion?._id) {
          state.factura.cajaSesion = { _id: state.cajaSesion._id, caja: state.cajaSesion.caja }
        }

        // valida si es bulk o normal. Si es una FE, elimina el bulkItem
        const bulkMode = rootState.facturacion.emisorStore.emisor?.bulkBillingModule && state.params.codigoActividad.documento.value !== '01'
        console.log('bulkMode', bulkMode)

        return service.create(state.factura, inventario, creaClave, productionOrder, cuentaContablePago, bulkMode, accounting, autoPago).then(result => {
          // si es PRO y se factura un producto, actualiza la lista de items (JIT-ITEM) a facturar
          if (Session.user.profile !== 'COMMUNITY' && Session.user.profile !== 'FACTURA' && !state.params.codigoActividad.modoLibre) {
            commit('inventario/itemStore/UPDATE_PRODUCTO_STOCK_BILLING_LIST', state.factura.detalleServicio.lineaDetalle, { root: true })
          }

          // si es un clon de proforma debe cambiar su estado a FACTURADA
          if (
            state.factura.informacionReferencia?.length &&
            state.factura.informacionReferencia[0].numero === '00000000000000000000000000000000000000000000000001'
          ) {
            console.log('cambiaEstadoProforma')
            const regex = /#([^#]+)#/g
            const matches = state.factura.informacionReferencia[0].razon.match(regex)
            const proformaId = matches.map(match => match.replace(regex, '$1'))[0]

            dispatch('cambiaEstadoProforma', { _id: proformaId, estado: 'FACTURADA' })
          }

          // agrega el mov de caja.
          if (state.cajaSesion?._id && !subscription) {
            const medio = state.factura.resumenFactura.medioPago.length
              ? state.factura.resumenFactura.medioPago[0].annotation?.split(' ')[0].toUpperCase()
              : 'ND'

            const montoServicio = state.factura.otrosCargos.reduce(
              (acc, item) => (item.detalle.toUpperCase() === 'SERVICIO' ? acc + item.montoCargo : acc),

              0
            )

            dispatch(
              'cajas/movimientoStore/create',
              {
                _idFactura: result.id,
                sesion: { _id: state.cajaSesion._id },
                cuentaContable: state.cajaSesion.cuentaContable,
                tipo: isFec ? 'COMPRA' : 'VENTA',
                montoIngreso: isFec ? 0 : state.factura.resumenFactura.totalComprobante,
                montoEgreso: isFec ? state.factura.resumenFactura.totalComprobante : 0,
                montoServicio,
                medioPago: medio,
                detalle: isFec ? `Factura Compra #${result.consecutivo}` : `Factura #${result.consecutivo}`
              },
              { root: true }
            )
          }

          if (!subscription) dispatch('cleanFactura')

          // actualiza la lista a credito: cuentas por cobrar, cuando son facturas
          if (['01', '04', '99'].includes(state.params.codigoActividad.documento.value)) {
            if (state.listaCredito.length) {
              dispatch('readDocumentosCredito', {
                restart: true,
                limit: 10,
                filter: null,
                isFEC: false,
                showContado: localStorage.getItem('showContadoCobrar') === 'true'
              })
            }
          } else if (['08', '998'].includes(state.params.codigoActividad.documento.value)) {
            // es una compra, estamos en inventario/facturaCompraStore, y debe llamar a rootState facturacion
            if (rootState.facturacion.facturaStore.listaCreditoCompras.length) {
              dispatch(
                'facturacion/facturaStore/readDocumentosCredito',
                {
                  restart: true,
                  limit: 10,
                  filter: null,
                  isFEC: true,
                  showContado: localStorage.getItem('showContadoPagar') === 'true'
                },
                { root: true }
              )
            }
          }

          Session.substractCounter()

          console.log('Resultado de facturación :>> ', result)

          return result
        })
      },

      async createNotaCredito({ state, dispatch }, { storeList, razon, creaClave = true, accounting = false }) {
        const listTipoDoc = await dispatch('facturacion/types/documento/list', {}, { root: true })
        const factura = state[storeList].id
        const documento = {}
        let inventario = false // true = doc: 99. en otros casos no modifica invetario hasta que la NC se acepte por MH.

        if (state[storeList].documento.value === '99') {
          inventario = true
          state[storeList].clave = '0000000000000000000000000000000000000000'
          documento.id = listTipoDoc.find(d => d.value === '993').id
        } else {
          documento.id = listTipoDoc.find(d => d.value === '03').id
        }

        // elimina campos innecesarios
        state[storeList].detalleServicio.lineaDetalle.forEach(linea => {
          if (linea.item.nombre !== undefined) {
            delete linea.item.nombre
          }
        })

        const { cuentaContableIVAPorPagar } = state.factura

        const notaCredito = {
          documento,
          situacionComprobante: { id: '' }, // set in backend
          local: { id: state[storeList].local?.id || state.params.local[0].id },
          terminal: { id: state[storeList].terminal?.id || state.params.local[0].terminal[0].id },
          codigoActividad: { id: state[storeList].codigoActividad.id },
          emisor: {
            id: state[storeList].emisor.id,
            nombre: state[storeList].emisor.nombre,
            identificacion: state[storeList].emisor.identificacion,
            nombreComercial: state.params.nombreComercial,
            ubicacion: {
              provincia: {
                id: state[storeList].emisor.ubicacion.provincia.id
              },
              canton: {
                id: state[storeList].emisor.ubicacion.canton.id
              },
              distrito: {
                id: state[storeList].emisor.ubicacion.distrito.id
              },
              otrasSenas: state[storeList].emisor.ubicacion.otrasSenas
            },
            correoElectronico: state[storeList].emisor.correoElectronico
          },
          ...(state[storeList].receptor && {
            receptor: {
              id: state[storeList].receptor.id,
              nombre: state[storeList].receptor.nombre,
              identificacion: state[storeList].receptor.identificacion,
              ...(state[storeList].receptor.identificacionExtranjero && {
                identificacionExtranjero: state[storeList].receptor.identificacionExtranjero
              }),
              correoElectronico: state[storeList].receptor.correoElectronico,

              // conta
              ...(state[storeList].receptor.cuentaContable && {
                cuentaContable: state[storeList].receptor.cuentaContable
              })
            }
          }),
          condicionVenta: { id: state[storeList].condicionVenta.id },
          plazoCredito: state[storeList].plazoCredito,
          // medioPago: state[storeList].medioPago.map(e => ({
          //   id: e.id
          // })),
          detalleServicio: state[storeList].detalleServicio,
          otrosCargos: state[storeList].otrosCargos
            ? state[storeList].otrosCargos.map(e => ({
                ...e,
                porcentajeOC: Number(e.porcentajeOC)
              }))
            : [],
          resumenFactura: {
            ...state[storeList].resumenFactura,
            codigoTipoMoneda: {
              codigoMoneda: {
                id: state[storeList].resumenFactura.codigoTipoMoneda?.codigoMoneda?.id || '5efcc43a1feb334e4d4933f4'
              },
              tipoCambio:
                state[storeList].resumenFactura.codigoTipoMoneda && state[storeList].resumenFactura.codigoTipoMoneda?.codigoMoneda.value !== 'CRC'
                  ? Number(parseFloat(state[storeList].resumenFactura.codigoTipoMoneda.tipoCambio).toFixed(5))
                  : 1
            }
          },
          informacionReferencia: [
            {
              tipoDocIR: { id: '' }, // id en backend.
              numero: state[storeList].clave,
              fechaEmisionIR: new Date(),
              codigo: { id: '' }, // id en backend: anula documento.
              razon
            }
          ],
          cuentaContableIVAPorPagar
        }

        notaCredito.codigoActividadEmisor = state.params.codigoActividad.codigoActividad.value || '000000'

        // eslint-disable-next-line no-console
        console.log('Nota Credito :>> ', JSON.stringify(notaCredito, null, 2))
        console.log('inventario :>> ', inventario)
        console.log('accounting :>> ', accounting)

        return service.createNotaCredito(factura, notaCredito, inventario, creaClave, accounting).then(result => {
          // agrega el mov de caja.
          if (state[storeList].cajaSesion) {
            dispatch(
              'cajas/movimientoStore/create',
              {
                _idFactura: result.id, // TODO: revisar si es el valor correcto.
                sesion: { _id: state[storeList].cajaSesion._id },
                tipo: 'CANCELACION_VENTA',
                montoIngreso: 0,
                montoEgreso: state[storeList].resumenFactura.totalComprobante,
                medioPago: state[storeList].resumenFactura.medioPago[0].annotation.split(' ')[0].toUpperCase(),
                detalle: `Nota Credito #${result.consecutivo}. ${razon}`
              },
              { root: true }
            )
          }

          dispatch('cleanFactura')

          // NC badge temporal, solo para notificar la NC en pantalla de lista de documentos.
          let tempFact = null
          if (state[storeList].documento.value === '01') tempFact = state.facturas.find(e => e.id === factura)
          else if (state[storeList].documento.value === '04') tempFact = state.tiquetes.find(e => e.id === factura)
          else if (state[storeList].documento.value === '09') tempFact = state.facturaExportacion.find(e => e.id === factura)
          else if (state[storeList].documento.value === '99') tempFact = state.facturaOtros.find(e => e.id === factura)

          if (tempFact) tempFact.notaCredito.push({ id: 0 })

          // NC badge temporal, solo para notificar la NC en pantalla en la lista de facturas a credito

          const ncFact = state.listaCredito.find(e => e.id === factura)
          if (ncFact) ncFact.notaCredito.push({ id: 0 })

          // NC badge temporal, solo para notificar la NC en pantalla en la lista de pagos
          // TODO: busca en la lista de pagos de pagoStore y aplica las notas de credito

          return result
        })
      },

      async createAnulaCompra({ state, dispatch, rootGetters }, { storeList, razon, inventario = false, accounting = false }) {
        // carga los tipos de documentos
        await dispatch('facturacion/types/documento/list', {}, { root: true })
        const factura = state[storeList].id
        const documento = {}
        const { cuentaContableIVAPorCobrar } = state.factura

        state[storeList].clave = '0000000000000000000000000000000000000000'
        // 9938 = Nota de credito de factura de compras otros.
        // todas las anulaciones de FEC son 9938 porque no deben ir a MH
        documento.id = rootGetters['facturacion/types/documento/get_Id']('9938') // 9938 anula compras: 05 - 995 - 08 - 998

        // elimina campos innecesarios
        state[storeList].detalleServicio.lineaDetalle.forEach(linea => {
          if (linea.item.nombre !== undefined) {
            delete linea.item.nombre
          }
        })

        const notaCredito = {
          documento,
          situacionComprobante: { id: '' }, // set in backend

          local: { id: state[storeList].local?.id || state.params.local[0].id },
          terminal: { id: state[storeList].terminal?.id || state.params.local[0].terminal[0].id },
          codigoActividad: { id: state[storeList].codigoActividad.id },
          emisor: {
            id: state[storeList].emisor.id,
            nombre: state[storeList].emisor.nombre,
            identificacion: state[storeList].emisor.identificacion,
            nombreComercial: state.params.nombreComercial,
            ubicacion: {
              provincia: {
                id: state[storeList].emisor.ubicacion.provincia.id
              },
              canton: {
                id: state[storeList].emisor.ubicacion.canton.id
              },
              distrito: {
                id: state[storeList].emisor.ubicacion.distrito.id
              },
              otrasSenas: state[storeList].emisor.ubicacion.otrasSenas
            },
            correoElectronico: state[storeList].emisor.correoElectronico,

            // conta
            ...(state[storeList].emisor.cuentaContable && {
              cuentaContable: state[storeList].emisor.cuentaContable
            })
          },
          ...(state[storeList].receptor && {
            receptor: {
              id: state[storeList].receptor.id,
              nombre: state[storeList].receptor.nombre,
              identificacion: state[storeList].receptor.identificacion,
              ...(state[storeList].receptor.identificacionExtranjero && {
                identificacionExtranjero: state[storeList].receptor.identificacionExtranjero
              }),
              correoElectronico: state[storeList].receptor.correoElectronico
            }
          }),
          condicionVenta: { id: state[storeList].condicionVenta.id },
          ...(state[storeList].plazoCredito && { plazoCredito: Number(state[storeList].plazoCredito) }),
          // medioPago: state[storeList].medioPago.map(e => ({
          //   id: e.id
          // })),
          detalleServicio: state[storeList].detalleServicio,
          otrosCargos: state[storeList].otrosCargos
            ? state[storeList].otrosCargos.map(e => ({
                ...e,
                porcentajeOC: Number(e.porcentajeOC)
              }))
            : [],
          resumenFactura: {
            ...state[storeList].resumenFactura,
            codigoTipoMoneda: {
              codigoMoneda: {
                id: state[storeList].resumenFactura.codigoTipoMoneda.codigoMoneda.id
              },
              tipoCambio:
                state[storeList].resumenFactura.codigoTipoMoneda?.codigoMoneda.value !== 'CRC'
                  ? Number(parseFloat(state[storeList].resumenFactura.codigoTipoMoneda.tipoCambio).toFixed(5))
                  : 1
            }
          },
          informacionReferencia: [
            {
              tipoDocIR: { id: '' }, // id en backend.
              numero: state[storeList].clave,
              fechaEmisionIR: new Date(),
              codigo: { id: '' }, // id en backend: anula documento.
              razon
            }
          ],
          cuentaContableIVAPorCobrar
        }

        // eslint-disable-next-line no-console
        console.log('Anulación Compra :>> ', JSON.stringify(notaCredito, null, 2))
        console.log('Inventario', inventario)
        console.log('Accounting', accounting)

        return service.createAnulaCompra(factura, notaCredito, inventario, accounting).then(result => {
          // agrega el mov de caja.
          if (state[storeList].cajaSesion) {
            dispatch(
              'cajas/movimientoStore/create',
              {
                _idFactura: result.id, // TODO: revisar si es el valor correcto.
                sesion: { _id: state[storeList].cajaSesion._id },
                tipo: 'CANCELACION_COMPRA',
                montoIngreso: state[storeList].resumenFactura.totalComprobante,
                montoEgreso: 0,
                medioPago: state[storeList].resumenFactura.medioPago[0].annotation.split(' ')[0].toUpperCase(),
                detalle: `Anulación #${result.consecutivo}. ${razon}`
              },
              { root: true }
            )
          }

          dispatch('cleanFactura')

          // NC badge temporal, solo para notificar la NC en pantalla de lista de documentos.
          let tempFact = null
          tempFact = state.compras.find(e => e.id === factura)
          if (tempFact) tempFact.notaCredito.push({ id: 0 })

          // NC badge temporal, solo para notificar la NC en pantalla en la lista de facturas a credito
          const ncFact = state.listaCreditoCompras.find(e => e.id === factura)
          if (ncFact) ncFact.notaCredito.push({ id: 0 })

          // NC badge temporal, solo para notificar la NC en pantalla en la lista de pagos
          // TODO: busca en la lista de pagos de pagoStore y aplica las notas de credito

          return result
        })
      },

      async cambiaEstadoProforma({ commit }, { _id, estado }) {
        return service.cambiaEstadoProforma(_id, estado).then(response => {
          if (response) commit('UPDATE_PROFORMAS', { _id, estadoProforma: estado })

          return response
        })
      },

      setFirst: (_, value) => service.setFirst(value),
      getCounters: ({}, _id) => service.getCounters(_id),

      readTotalDocumentos: ({ state }, documento) =>
        service.readTotalDocumentos(state.params.emisorId, documento).then(response => {
          if (documento === '01') state.totalRegistrosFe = response
          else if (documento === '02') state.totalRegistrosNd = response
          else if (documento === '03') state.totalRegistrosNc = response
          else if (documento === '04') state.totalRegistrosTe = response
          else if (documento === '05') state.totalRegistrosMr = response
          else if (documento === '08') state.totalRegistrosFec = response
          else if (documento === '09') state.totalRegistrosFee = response
          else if (documento === '99') state.totalRegistrosOtros = response
        }),

      readTotalDocumentosCobrar: ({ state }, { showContado = false }) =>
        service.readTotalDocumentosCobrar(state.params.emisorId, showContado).then(response => {
          state.totalRegistrosCobrar = response
        }),

      readTotalDocumentosPagar: ({ state }, { showContado = false }) =>
        service.readTotalDocumentosPagar(state.params.emisorId, showContado).then(response => {
          state.totalRegistrosPagar = response
        }),

      reSendEmail: (_, { id, email }) => service.reSendEmail({ id, email }),

      checkCodigoExonet(_, cabysArray) {},

      facturacionCounter: ({ state }) => service.facturacionCounter(state.params.emisorId),

      sendMailEstadoCuenta: (_, { emisor, logo, receptor }) => service.sendMailEstadoCuenta(emisor, logo, receptor),

      addAttachment: ({ dispatch }, { _idEmisor, _idFactura, src, name, detail }) =>
        service.addAttachment(_idEmisor, _idFactura, src, name, detail).then(() => {
          dispatch('readAttachments', { _idFactura })
        }),

      deleteAttachment: ({ dispatch }, { _idFactura, _id, src }) =>
        service.deleteAttachment(_idFactura, _id, src).then(() => {
          dispatch('readAttachments', { _idFactura })
        }),

      readAttachments: ({ state }, { _idFactura }) =>
        service.readAttachments(_idFactura).then(result => {
          state.adjuntos = result
        }),

      setCreatedAt: ({}, { _idFactura, createdAt }) => service.setCreatedAt(_idFactura, createdAt)
    }
    this.getters = {
      getFactura: state => _id => state.facturas.find(e => e.id === _id),
      getTiquete: state => _id => state.tiquetes.find(e => e.id === _id),
      getNotaCredito: state => _id => state.notasCredito.find(e => e.id === _id),
      getMensajeReceptor: state => _id => state.mensajesReceptor.find(e => e.id === _id),
      getCompras: state => _id => state.compras.find(e => e.id === _id),
      getFacturaExportacion: state => _id => state.facturaExportacion.find(e => e.id === _id),
      getFacturaOtros: state => _id => state.facturaOtros.find(e => e.id === _id),
      getSuscripcion: state => _id => state.suscripcion.find(e => e.id === _id),
      getFacturaCredito: state => _id => state.listaCredito.find(e => e.id === _id),
      getFacturaCreditoCompras: state => _id => state.listaCreditoCompras.find(e => e.id === _id),
      getAnulacionCompras: state => _id => state.anulacionCompras.find(e => e.id === _id),
      readProformaById: state => _id => state.listaProforma.find(e => e.id === _id),
      getCajaSesion: state => state.cajaSesion,
      getParams: state => state.params
    }
  }
}
